import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useRootStore } from '@nandosaus/state-management';
import { Flex } from '../grid';
import { useNavPadding } from '../../hooks/use-nav-padding';

const FormBackgroundStyle = styled(Flex)`
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%), url(${props => props.imageUrl});
  background-size: cover;
  background-position: center;
  flex: 1;
`;

const FormBackground = ({ children }) => {
  const { mobileNavPadding, desktopNavPadding } = useNavPadding();
  const { UIStore } = useRootStore();

  // Override layout's default navbar theme - setTimeout ensures this runs after layout's useEffect
  useEffect(() => {
    const timer = setTimeout(() => {
      UIStore.setNavbarLight();
    }, 0);
    return () => clearTimeout(timer);
  }, [UIStore]);

  return (
    <FormBackgroundStyle
      pt={{ xs: mobileNavPadding, lg: desktopNavPadding }}
      imageUrl="/static/images/account/Account-Background.jpg"
    >
      {children}
    </FormBackgroundStyle>
  );
};

FormBackground.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FormBackground;
